import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { Button as StyledButton, SectionContainer } from '../styles';
export const Button = ({ section }) => {
    const theme = useTheme();
    const buttonOnClickHandler = () => window.open(section.link);
    return (_jsx(SectionContainer, { children: _jsx(StyledButton, { onClick: buttonOnClickHandler, textColor: theme.textButtons, backgroundColor: theme.buttons, children: section.text }) }));
};
